import Accordion from 'react-bootstrap/Accordion'
import Alert from 'react-bootstrap/Alert'
import Button from 'react-bootstrap/Button'

import { formatBalance } from '../utils/helpers'
import { useEnvironmentStore } from '../zustand/environmentStore'

const Faucet = () => {
    const { publicKey, balance } = useEnvironmentStore()

    return (
        <Accordion.Item eventKey='1'>
            <Accordion.Header><b>1 - Faucet</b></Accordion.Header>
            <Accordion.Body>
                <p>Balance: {formatBalance(balance, 4)} COTI</p>

                <Alert variant='info' className='deployed-contracts-alert'>Request funds by writing "testnet {publicKey !== '' ? publicKey : '\<PUBLIC_KEY\>'}" in the #coti-faucet channel of the COTI Discord</Alert>

                <Button size='sm' href='https://faucet.coti.io' target='_blank' className='discord-btn'>Open Discord</Button>
            </Accordion.Body>
        </Accordion.Item>
    )
}

export default Faucet